/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
function NullDependencyTemplate() {}
module.exports = NullDependencyTemplate;

NullDependencyTemplate.prototype.apply = function() {};



//////////////////
// WEBPACK FOOTER
// (webpack)/lib/dependencies/NullDependencyTemplate.js
// module id = 2513
// module chunks = 0